import { Component, Input } from '@angular/core';
import { LovableMediaItem } from './lovable-dashboard.models';

@Component({
    selector: 'app-lovable-media-grid',
    templateUrl: './lovable-media-grid.component.html',
    styleUrls: ['./lovable-media-grid.component.css'],
})
export class LovableMediaGridComponent {
    @Input() media: LovableMediaItem[] = [];

    readonly displayCount = 4;

    sliceMedia(): LovableMediaItem[] {
        return this.media.slice(0, Math.min(this.media.length, this.displayCount));
    }

    count(): number {
        return Math.min(this.media.length, this.displayCount);
    }

    imgSrc(item: LovableMediaItem): string {
        return item.type === 'video' ? item.thumbnail || item.url : item.url;
    }
}
